import { Input } from '@creanizer/ui'
import { Label } from '@creanizer/ui'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@creanizer/ui'
import { Slider } from '@creanizer/ui'
import { Alert, AlertDescription } from '@creanizer/ui'
import { RadioGroup, RadioGroupItem } from '@creanizer/ui'
import { Package } from 'lucide-react'
import type { SkillInput } from '@creanizer/types'

interface SkillFormBatchProps {
  input: SkillInput
  onChange: (input: SkillInput) => void
}

export function SkillFormBatch({ input, onChange }: SkillFormBatchProps) {
  return (
    <div className="space-y-6">
      <Alert>
        <Package className="h-4 w-4" />
        <AlertDescription>
          複数のスキルを一度に生成します。キャラクターのスキルセットやジョブのスキルツリーなどに最適です。
        </AlertDescription>
      </Alert>
      
      <div className="space-y-2">
        <Label>生成数（1-25）</Label>
        <Slider
          value={[input.numberOfSkills || 5]}
          onValueChange={([value]) => onChange({ ...input, numberOfSkills: value })}
          max={25}
          min={1}
          step={1}
        />
        <p className="text-sm text-muted-foreground">
          {input.numberOfSkills || 5}個のスキルを生成
        </p>
        <p className="text-xs text-muted-foreground">
          ※ 5個ごとに1回のAPIを使用します（例: 18個 = 4回のAPI使用）
        </p>
      </div>
      
      <div className="space-y-2">
        <Label htmlFor="batchTheme">テーマ・コンセプト</Label>
        <Input
          id="batchTheme"
          value={input.batchTheme || ''}
          onChange={(e) => onChange({ ...input, batchTheme: e.target.value })}
          placeholder="例: 炎の魔法使いのスキルセット、暗殺者の技能"
        />
      </div>
      
      <div className="space-y-2">
        <Label>生成パターン</Label>
        <RadioGroup
          value={input.batchPattern || 'random'}
          onValueChange={(value: any) => onChange({ ...input, batchPattern: value })}
        >
          <div className="flex items-center space-x-2">
            <RadioGroupItem value="random" id="random" />
            <Label htmlFor="random">ランダム（多様なスキル）</Label>
          </div>
          <div className="flex items-center space-x-2">
            <RadioGroupItem value="set" id="set" />
            <Label htmlFor="set">セット（相乗効果のあるスキル群）</Label>
          </div>
          <div className="flex items-center space-x-2">
            <RadioGroupItem value="progression" id="progression" />
            <Label htmlFor="progression">段階的（初級→上級への成長）</Label>
          </div>
          <div className="flex items-center space-x-2">
            <RadioGroupItem value="variations" id="variations" />
            <Label htmlFor="variations">バリエーション（基本スキルの派生）</Label>
          </div>
        </RadioGroup>
      </div>
      
      {input.batchPattern === 'progression' && (
        <div className="space-y-2">
          <Label>成長タイプ</Label>
          <Select
            value={input.progressionType || 'linear'}
            onValueChange={(value: any) => onChange({ ...input, progressionType: value })}
          >
            <SelectTrigger>
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="linear">直線的（順番に強化）</SelectItem>
              <SelectItem value="branching">分岐型（複数の発展方向）</SelectItem>
              <SelectItem value="specialization">特化型（専門分野へ特化）</SelectItem>
            </SelectContent>
          </Select>
        </div>
      )}
    </div>
  )
}